import { ProductServiceTypeEnum } from '../../constants/product.constants';
var CustomerProductHoldingUtil = /** @class */ (function () {
    function CustomerProductHoldingUtil() {
    }
    CustomerProductHoldingUtil.hasDTVAndInternet = function (customerProductHolding) {
        return this.hasDTV(customerProductHolding) && this.hasInternet(customerProductHolding);
    };
    CustomerProductHoldingUtil.hasDTV = function (customerProductHolding) {
        var _this = this;
        return customerProductHolding.some(function (product) {
            var bundleHasDTV = product.servicetype && product.servicetype.includes(ProductServiceTypeEnum.DTV);
            var childProductsHaveDTV = _this.hasDTV(product.products);
            return bundleHasDTV || childProductsHaveDTV;
        });
    };
    CustomerProductHoldingUtil.hasInternet = function (customerProductHolding) {
        var _this = this;
        return customerProductHolding.some(function (product) {
            var bundleHasDTV = product.servicetype && product.servicetype.includes(ProductServiceTypeEnum.FIXED_INTERNET);
            var childProductsHaveDTV = _this.hasInternet(product.products);
            return bundleHasDTV || childProductsHaveDTV;
        });
    };
    CustomerProductHoldingUtil.ownsTvShopEntertainmentPack = function (streamingService, customerProductHolding) {
        var _this = this;
        return customerProductHolding.some(function (product) {
            var omapiId = _this.getOmapiIdFromSpecUrl(product.specurl);
            if (omapiId === streamingService.omapiId) {
                return true;
            }
            return product.options.some(function (option) {
                var optionOmapiId = _this.getOmapiIdFromSpecUrl(option.specurl);
                return optionOmapiId === streamingService.omapiId;
            });
        });
    };
    CustomerProductHoldingUtil.getOmapiIdFromSpecUrl = function (specUrl) {
        return specUrl.split('/').pop();
    };
    return CustomerProductHoldingUtil;
}());
export { CustomerProductHoldingUtil };
